import { render, staticRenderFns } from "./AdditionalDealKpiDataView.vue?vue&type=template&id=14958f2a&"
import script from "./AdditionalDealKpiDataView.vue?vue&type=script&lang=js&"
export * from "./AdditionalDealKpiDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports